import React, { useState, useEffect } from 'react'
import { useDispatch } from "react-redux"
import gameActions from "../../../store/actions/gameActions"
import Loading from '../../Loading'
import Button from '../../Button';

function shuffle(a) {
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}

const WordSearch = ({ data }) => {

    const [state, setState] = useState({
        isOpen: true,
        isDone: false,
        isLoading: true,
        characters: [],
        words: data,
        completedWords: 0,
        numberOfWords: data.length,
        inputContent: '',
        inputContentIndexes: [],
        askAnswers: false
    })

    const getRandomCharacters = () => {
        const allCharacters = 'abcdefghijklmnopqrstuvwxyz';
        const allCharactersLength = allCharacters.length;
        const randomCharacters = [];

        for (let item of state.words) {
            item["isDone"] = false;
            let word = item.word;
            [...word].forEach(text => randomCharacters.push({ character: text, disabled: false, isRight: true }));
        }

        for (let i = 0; i < parseInt(randomCharacters.length / 2); i++) {
            randomCharacters.push({ character: allCharacters.charAt(Math.floor(Math.random() * allCharactersLength)), disabled: false, isRight: false })
        }

        const returnCharacters = shuffle(randomCharacters);
        setState({ ...state, characters: returnCharacters, isLoading: false });
    }

    const pressCharacter = (sentCharacter, sentIndex) => {
        state.characters[sentIndex].disabled = true
        let updateInputContent = state.inputContent.concat(sentCharacter)
        setState({ ...state, inputContent: updateInputContent, inputContentIndexes: state.inputContentIndexes.concat(sentIndex) })
        for (let item of state.words) {
            if (item.word === state.inputContent.concat(sentCharacter)) {
                item.isDone = true
                setState({ ...state, inputContent: '', inputContentIndexes: [], completedWords: state.completedWords += 1 })
            }
        }
        if (state.completedWords === state.words.length) {
            dispatch(gameActions.unlockAdvancedNarrative('sopa de letras'))
        }
    }

    const deleteCharacter = () => {
        let length = state.inputContentIndexes.length
        let lastIndex = state.inputContentIndexes[length - 1]
        state.characters[lastIndex].disabled = false
        state.inputContentIndexes.pop()
        setState({ ...state, inputContent: state.inputContent.slice(0, -1), inputContentIndexes: length === 1 ? [] : state.inputContentIndexes })
    }

    const cleanInput = () => {
        for (let item of state.characters) {
            if (!item.isRight || item.disabled) {
                item.disabled = false;
            }
        }
        setState({ ...state, inputContent: '', inputContentIndexes: [] })
    }

    useEffect(() => {
        getRandomCharacters()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const dispatch = useDispatch()
    const { isLoading, characters, words, inputContent } = state

    return (
        isLoading ? <Loading /> :
            <div>
                <div className='py-4'>
                    <h4 className='pb-0'>Sopa de letras</h4>
                    <p className='pb-6'>Encontre todas as palavras que são sugeridas pelas pistas para conseguir avançar!<span className='orange-highlight'>*</span></p>
                    <p className='text-sm mb-6'><span className='orange-highlight'>*</span>Se não conseguir encontrar todas as palavras utilize o botão de mostrar resultados.</p>

                    <h5 className='w-100 pb-2'>Pistas</h5>
                    <div className='d-flex justify-content-center mb-4'>
                        {words.map((item, index) => (
                            <p
                                className='m-0'
                                style={{ textDecoration: item.isDone ? "line-through" : 'none', color: item.isDone ? '' : 'default' }}
                                key={index}
                            >
                                {item.hint}
                                {state.askAnswers && ` - ${item.word}`}
                            </p>
                        ))}
                    </div>

                    <Button onClick={() => setState({ ...state, askAnswers: !state.askAnswers })} className='mb-6'
                    >
                        {!state.askAnswers ? `Mostrar ` : `Esconder `}respostas
                    </Button>

                    <div className='py-3'>
                        <label className="block text-gray-700 font-bold mb-2">
                            <span>Palavra inserida</span>
                            <input
                                placeholder="Carregue nas letras para começar a construir palavras"
                                value={inputContent}
                                className="text-lg shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 my-3"
                            />
                            <Button disabled={!inputContent ? true : false} onClick={() => !inputContent ? null : deleteCharacter()}>
                                Apagar letra
                            </Button>
                            <Button onClick={cleanInput} disabled={state.completedWords === state.words.length || !inputContent ? true : false}>
                                Apagar tudo
                            </Button>
                        </label>
                    </div>

                    <div className='grid gap-3 grid-cols-2 sm:grid-cols-4 md:grid-cols-6'>
                        {characters.map((item, index) => (
                            <Button
                                id={index}
                                key={index}
                                disabled={item.disabled ? true : false}
                                className='minigameButton text-center justify-center minigameButton mr-0'
                                onClick={() => pressCharacter(item.character, index)}
                            >
                                {item.character}
                            </Button>
                        ))}
                    </div>
                </div>
            </div>
    )
}

export default WordSearch
